import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { style: {"min-height":"100vh"} }
const _hoisted_4 = {
  class: "h-100 d-flex flex-column justify-content-center align-items-center",
  style: {"max-width":"95%","margin":"0 auto"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Gym Program", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "row g-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://thumbs.dreamstime.com/b/cartoon-background-gym-room-hand-drawn-fitness-center-interior-fitness-79995047.jpg",
    alt: "Exercise Image",
    class: "img-fluid rounded-start",
    width: "125",
    height: "125"
  })
], -1)
const _hoisted_11 = { class: "col-md-8" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-text" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "card-text" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Remove Exercise")

import { ExerciseResultType } from '@/types/exercise-types'
import { ref, Ref } from 'vue'
import { useToast } from 'vuestic-ui'
import HomeCarousel from '../components/HomeCarousel.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgramView',
  setup(__props) {

const { init } = useToast()
const exercise: Ref<ExerciseResultType|undefined> = ref(undefined)
const showModal: Ref<boolean> = ref(false)
const programList: Ref<ExerciseResultType[]> = ref(JSON.parse(localStorage.getItem('program')))
function handleShow(newExercise: ExerciseResultType): void {
  exercise.value = newExercise
  showModal.value = !showModal.value
}
function removeExercise(exerciseToDelete: ExerciseResultType) {
  let program: ExerciseResultType[] = programList.value
  program = program.filter((exercise) => exercise !== exerciseToDelete)
  localStorage.setItem('program', JSON.stringify(program))
  programList.value = program
  init({ message: 'Removed!', color: 'success' })
  showModal.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_va_badge = _resolveComponent("va-badge")!
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        (programList.value?.length<1)
          ? (_openBlock(), _createBlock(HomeCarousel, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programList.value, (exercise, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card mb-3 w-100",
            key: i,
            onClick: ($event: any) => (handleShow(exercise)),
            style: {"max-width":"800px","max-height":"200px"}
          }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(exercise.name.replace(/\w+/g,function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();})), 1),
                  _createElementVNode("p", _hoisted_14, [
                    _createElementVNode("small", _hoisted_15, _toDisplayString(exercise.target.replace(/\w+/g,function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();})), 1)
                  ]),
                  _createElementVNode("p", _hoisted_16, [
                    _createVNode(_component_va_badge, {
                      text: exercise.equipment,
                      color: "success"
                    }, null, 8, ["text"])
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_8))
        }), 128)),
        (exercise.value)
          ? (_openBlock(), _createBlock(_component_va_modal, {
              key: 1,
              modelValue: showModal.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
              size: "large",
              "no-padding": ""
            }, {
              content: _withCtx(() => [
                _createVNode(_component_va_image, {
                  ratio: 0.75,
                  src: exercise.value.gifUrl
                }, null, 8, ["ratio", "src"]),
                _createVNode(_component_va_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, {
                      flat: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value=false)),
                      "text-color": "#acb5be"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_button, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (removeExercise(exercise.value))),
                      color: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})